import { forwardRef, type Ref, type SVGProps } from "react";
const IconBatteryFullFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M28 12V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2v-4a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2m-4 9H6V10h18z" /><path fill="currentColor" d="M8 12h14v7H8z" /></svg>;
const ForwardRef = forwardRef(IconBatteryFullFilledSVG);
ForwardRef.displayName = "IconBatteryFullFilled";
export { ForwardRef as IconBatteryFullFilled };